import React, { createContext, useContext } from 'react';

// True only for the unauthenticated "/try" flow — Builder/FloorPlan/RoomEditor/
// House3DView all read this to swap cloud-save UI for a "Save & Sign Up" button,
// hide screenshot export (nothing to export to yet), and lock most materials
// behind a "Sign up for more" overlay.
const GuestModeContext = createContext(false);

export function GuestModeProvider({ value, children }) {
  return <GuestModeContext.Provider value={value}>{children}</GuestModeContext.Provider>;
}

export function useGuestMode() {
  return useContext(GuestModeContext);
}
